"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _bind2 = _interopRequireDefault(require("classnames/bind"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _withStyles = _interopRequireDefault(require("../utils/withStyles"));

var _wizard = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/wizard.css") : void 0);

// import { WIZARD_SIZES } from './Wizard';
var classnames = (0, _bind.default)(_bind2.default).call(_bind2.default, _wizard.default);
var WIZARD_SIZES = process.env.NODE_ENV !== "production" ? ['sm', 'md', 'lg', 'xl'] : {};
/** WizardContainer is a wrapper for wizard navigation bar. It is meant to be
 * used with `Wizard.Step` components as children when building the wizard
 * manually, without the build-in logic.
 *
 * @returns {Node} WizardContainer component
 */

function WizardNavigation(_ref) {
  var _context, _classnames;

  var children = _ref.children,
      className = _ref.className,
      cssNamespace = _ref.cssNamespace,
      size = _ref.size,
      props = (0, _objectWithoutProperties2.default)(_ref, ["children", "className", "cssNamespace", "size"]);
  var navigationClasses = classnames("".concat(cssNamespace, "-wizard__navigation"), className);
  var progressBarClasses = classnames((_classnames = {}, (0, _defineProperty2.default)(_classnames, "".concat(cssNamespace, "-wizard__progress-bar"), true), (0, _defineProperty2.default)(_classnames, (0, _concat.default)(_context = "".concat(cssNamespace, "-wizard__progress-bar--")).call(_context, size), size), _classnames));
  return /*#__PURE__*/_react.default.createElement("nav", (0, _extends2.default)({
    className: navigationClasses
  }, props), /*#__PURE__*/_react.default.createElement("ul", {
    className: progressBarClasses
  }, children));
}

process.env.NODE_ENV !== "production" ? WizardNavigation.propTypes = {
  /** Wizard.Step nodes to render as steps */
  children: _propTypes.default.node,

  /** CSS class(es) to add to the element */
  className: _propTypes.default.string,

  /** By default wizard header has no horizontal paddings. Add a size to modify the padding */
  size: _propTypes.default.oneOf(WIZARD_SIZES)
} : void 0;

var _default = (0, _withStyles.default)(WizardNavigation);

exports.default = _default;